import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import {
    combineFirstAndLastName,
    getNetworkResponseError,
    isStatusOK,
    getUTCTimeStamp,
} from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const PRODUCT_ID = '1012222303009777000'
const TYPE = 'Savings'
const beneficiaryType = 'DMR'

const parsedDataBody = (body: any) => {
  return {
    remitterId: body?.remittanceUserId,
    productId: PRODUCT_ID,
    accountNumber: body?.beneficiaryAccountNumber,
    accountHolderName: body?.accountHolderName,
    nickName: combineFirstAndLastName(body?.beneficiaryFirstName ?? '', body?.beneficiaryLastName ?? ''),
    accountType: TYPE?.toUpperCase(),
    ifscCode: body?.ifscCode,
    mobileNumber: {
      countryCode: '91',
      number: body?.mobile,
    },
    beneficiaryType: beneficiaryType,
    createdBy: RootStore?.agent?.session?.CHANNEL_ID,
    createdFromChannel: RootStore?.agent?.session?.CHANNEL_ID,
    field5: 'B93,B94',
  }
}

const responseParser = (data: any) => {
    if (data?.data?.status === 'F') {
        throw {
            code: data.data.errorCode,
            message: data.data.errorMessage,
        }
    }
    if (isStatusOK(data)) {
        const agentStatus = data?.data?.responseObj?.agent?.agentStatus;
        if (agentStatus) {
            return agentStatus;
        }
        return data?.data?.responseObj;
    } else {
        throw getNetworkResponseError(data?.data)
    }
}

const formatCurrentDateForApi = (): string => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    
    return `${year}-${month}-${day}`;
};

const getAgentOnboardingRequestBody = (body: any) => {
    const agentInfoV3 = RootStore.agent.agentInfoV3;
    const deviceInfo = RootStore.agent.deviceInfo;
    
    const fullName = [agentInfoV3.firstName, agentInfoV3.middleName, agentInfoV3.lastName]
        .filter(name => name)
        .join(' ');
    
    const agentDetailsV3 = agentInfoV3.agent;

    return {
        agent: {
            name: fullName || agentInfoV3.name || 'N/A',
            aliasName: agentInfoV3.name || 'N/A',
            mobileNo: agentInfoV3.mobileNumber || 'N/A',
            shopName: agentDetailsV3?.organization || 'N/A',
            businessType: 'Mobile',
            registeredAddress: agentDetailsV3?.address || 'N/A',
            registeredState: agentDetailsV3?.stateCode || 'N/A',
            registeredCity: agentDetailsV3?.city || 'N/A',
            registeredCountry: 'India',
            registeredPinCode: agentDetailsV3?.pinCode || 'N/A',
            latitude: deviceInfo.latitude || '0.0',
            longitude: deviceInfo.longitude || '0.0',
            agentInstituteId: body?.agentInstituteId || RootStore.agent.CLIENT_ID || 'N/A',
            merchantId: agentInfoV3.loginId || RootStore.agent.agentInfo.agentUserLoginId || 'N/A',
            effectiveFromDate: body?.effectiveFromDate || formatCurrentDateForApi(),
            effectiveToDate: body?.effectiveToDate || '9999-12-31',
            consentCode: body?.consentCode || 'B88',
            consentAuthenticationMode: body?.consentAuthenticationMode || 1,
            consentCreatedDateAndTime: body?.consentCreatedDateAndTime || new Date().toISOString(),
            paymentModes: 'Cash,Card,UPI',
            paymentChannels: 'POS,Online',
            paymentCollectionMode: 'ONLINE',
            merchantUserId: body?.merchantUserId || 'N/A',
            feeInfo: agentInfoV3.appData?.feeInfo || { feeType: 'Flat', feeAmount: '0.00', currency: 'INR' },
            customerInfo: agentInfoV3.appData?.customerInfo || { customerId: 'CUST001', customerName: fullName || 'N/A' },
        },
    };
};

export const agentOnboardingApiV3 = (tokens: any, body: any) => {
    let config = sitConfig(tokens) as any
    config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
    config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

    const agentInfoV3 = RootStore.agent.agentInfoV3;
    const deviceInfo = RootStore.agent.deviceInfo;

    console.log(`Agent V3 Information: ${JSON.stringify(agentInfoV3)}`);
    console.log(`Device Information: ${JSON.stringify(deviceInfo)}`);

    const requestBody = getAgentOnboardingRequestBody(body);
    
    const request: Request<{}> = {
        apiPath: APIEndPoints.bbpsAgentOnboard,
        method: 'POST',
        config: config,
        body: requestBody,
    }
    sendEventApi(tokens, request, {
        status: 'INITIATED',
    })
    return executeRequest(request)
        .then((data) => {
            console.log(data, 'Akanksha see what data we are sending to respponse parse agentOnboardingApi bbpsAgentOnboard')
            return responseParser(data)
        })
        .then((response) => {
            sendEventApi(tokens, request, {
                status: 'SUCCESS',
            })
            return response
        })
        .catch((err) => {
            sendEventApi(tokens, request, {
                status: 'FAILED',
                errorDescription: err,
            })
            throw err
        })
}